import {
  Dashboard as DashboardIcon,
  AccountBalance as AccountBalanceIcon,
  AccountBalance,
  AccountBalanceWallet as WalletIcon,
  Book as BookIcon,
  TableChart as BalanceIcon,
  People as PeopleIcon,
  Receipt as ReceiptIcon,
  ShoppingCart as ShoppingCartIcon,
  TrendingUp as IncomeIcon,
  ShoppingBag as ExpenseIcon,
  Savings as BudgetIcon,
  Business as AssetIcon,
  Inventory as InventoryIcon,
  Gavel as TaxIcon,
  CompareArrows as ReconIcon,
  Assessment as ReportIcon,
  Lock as CloseIcon,
  Settings as SettingsIcon,
  EventRepeat as AccrualIcon,
  FolderSpecial as ProjectsIcon,
  History as AuditIcon,
  Functions as CostingIcon,
} from '@mui/icons-material';
import { RESOURCES, ACTIONS } from '../../../hooks/useAccessControl';

const R = (resource) => ({ resource, action: ACTIONS.READ });

export const accountingMenu = {
  id: 'accounting-ledger',
  label: 'Accounting',
  icon: AccountBalanceIcon,
  children: [
    {
      type: 'group',
      id: 'ledger-overview',
      label: 'Overview',
      children: [
        { id: 'ledger-dashboard', label: 'Dashboard', icon: DashboardIcon, permission: R(RESOURCES.LEDGER.DASHBOARD) },
        { id: 'ledger-reports', label: 'Financial Reports', icon: ReportIcon, permission: R(RESOURCES.LEDGER.REPORTS) },
      ],
    },
    {
      type: 'group',
      id: 'ledger-books',
      label: 'Books',
      children: [
        { id: 'ledger-coa', label: 'Chart of Accounts', icon: AccountBalance, permission: R(RESOURCES.LEDGER.COA) },
        { id: 'ledger-gl', label: 'General Ledger', icon: BookIcon, permission: R(RESOURCES.LEDGER.GL) },
        { id: 'ledger-accruals', label: 'Accruals & Deferrals', icon: AccrualIcon, permission: R(RESOURCES.LEDGER.GL) },
        { id: 'ledger-balances', label: 'Balances & Recons', icon: BalanceIcon, permission: R(RESOURCES.LEDGER.GL) },
        { id: 'ledger-cash', label: 'Cash & Bank', icon: WalletIcon, permission: R(RESOURCES.LEDGER.CASH) },
      ],
    },
    {
      type: 'group',
      id: 'ledger-school-flows',
      label: 'School Flows',
      children: [
        { id: 'ledger-receivables', label: 'Student Receivables', icon: PeopleIcon, permission: R(RESOURCES.LEDGER.RECEIVABLES) },
        { id: 'ledger-fees', label: 'Fees & Billing', icon: ReceiptIcon, permission: R(RESOURCES.LEDGER.FEES) },
        { id: 'ledger-ap', label: 'Accounts Payable', icon: ShoppingCartIcon, permission: R(RESOURCES.LEDGER.AP) },
        { id: 'ledger-income', label: 'Income', icon: IncomeIcon, permission: R(RESOURCES.LEDGER.INCOME) },
        { id: 'ledger-expenses', label: 'Expenses', icon: ExpenseIcon, permission: R(RESOURCES.LEDGER.EXPENSES) },
      ],
    },
    {
      type: 'group',
      id: 'ledger-stewardship',
      label: 'Stewardship',
      children: [
        { id: 'ledger-budgeting', label: 'Budgeting', icon: BudgetIcon, permission: R(RESOURCES.LEDGER.BUDGETING) },
        { id: 'ledger-projects', label: 'Projects & Grants', icon: ProjectsIcon, permission: R(RESOURCES.LEDGER.BUDGETING) },
        { id: 'ledger-costing', label: 'Costing', icon: CostingIcon, permission: R(RESOURCES.LEDGER.BUDGETING) },
        { id: 'ledger-assets', label: 'Assets', icon: AssetIcon, permission: R(RESOURCES.LEDGER.ASSETS) },
        { id: 'ledger-inventory', label: 'Inventory', icon: InventoryIcon, permission: R(RESOURCES.LEDGER.INVENTORY) },
      ],
    },
    {
      type: 'group',
      id: 'ledger-compliance',
      label: 'Compliance',
      children: [
        { id: 'ledger-tax', label: 'Tax & Statutory', icon: TaxIcon, permission: R(RESOURCES.LEDGER.TAX) },
        { id: 'ledger-recon', label: 'Bank Reconciliation', icon: ReconIcon, permission: R(RESOURCES.LEDGER.RECON) },
        { id: 'ledger-close', label: 'Period Closing', icon: CloseIcon, permission: R(RESOURCES.LEDGER.CLOSE) },
        { id: 'ledger-audit', label: 'Audit Trail', icon: AuditIcon, permission: R(RESOURCES.LEDGER.REPORTS) },
        { id: 'ledger-settings', label: 'Accounting Settings', icon: SettingsIcon, permission: R(RESOURCES.LEDGER.SETTINGS) },
      ],
    },
  ],
};
